import { C4_ROWS, type C4Snapshot } from '@xox/shared'
import { createDuelStore } from './duel'

/** Connect Four rooms. A landing disc thuds. */
export const useC4Room = createDuelStore<C4Snapshot>({
  wsPath: '/ws/c4',
  moveMessage: (col, expectedSeq) => ({ type: 'move', col, expectedSeq }),
  canMove: (snap, col) => (snap.game.heights[col] ?? C4_ROWS) < C4_ROWS,
  moveEffects: () => ['thud'],
})
